import { FileApiService } from '../../../../data-transfer/services/file-api-service';
import { AuthService } from './../../../../services/auth-service';
import { MaterialApiService } from '../../../../data-transfer/services/material-api-service';
import { ComponentCanDeactivate } from './../../../../services/unsaved-changes-guard';
import { ActivatedRoute, Router } from '@angular/router';
import { MultiMaterialCompositeDto } from '../../../../data-transfer/entities/material-entities/multi-material-composite-dto';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CreateUpdateHandler } from './../../../../services/packaging-services/create-update-handler';
import { Component, OnInit, HostListener, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MaterialNavigationService } from 'src/app/navigation/services/navigation-services/material-navigation.service';
import { MatDialog } from '@angular/material/dialog';
import { CreateUpdatePackagingPartComponent } from 'src/app/components/shared-components/parent-components/create-update-packaging-part/create-update-packaging-part.component';
import { ColorThemeService } from 'src/app/navigation/services/color-theme-service';
import { VersionDto } from 'src/app/data-transfer/entities/version-dto';
import { PackagingComponentTypesEnum } from 'src/app/model/packaging-component-types-enum';
import { MaterialFunctionDto } from 'src/app/data-transfer/entities/material-function-dto';
import { MultiMaterialTableComponent } from 'src/app/components/shared-components/multi-material-table/multi-material-table.component';
import { CompositeMaterialSevice } from 'src/app/services/material-services/composite-material-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PackagingPart } from 'src/app/model/packaging-part-enum';
import { CoreDataUpdateService } from 'src/app/data-transfer/services/core-data-update-api-service';
import { DataExchangeRequestApiService } from 'src/app/data-transfer/services/data-exchange-request-api-service';
import { PathResolveService } from 'src/app/services/path-resolve.service';
import { SimpleAlertDialogComponent, SimpleDialogData } from 'src/app/components/dialogs/simple-alert-dialog/simple-alert-dialog.component';
import { getDialogConfig } from 'src/app/util/dialog-util';
import { DialogActions } from 'src/app/model/dictionary';
import { DirectoryApiService } from 'src/app/data-transfer/services/directory-api-service';
import { TranslocoService } from '@jsverse/transloco';
import { CreateDataExchangeRequestDialogComponent, CreateDataExchangeRequestDialogData } from 'src/app/components/directory-tree/dialogs/create-data-exchange-request-dialog/create-data-exchange-request-dialog.component';
import { DataExchangeSubRequestInfoDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/data-exchange-sub-request-info-dto';
import { DataExchangeRequestDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/data-exchange-request-dto';
import { DataExchangeRequestStatusDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/data-exchange-request-status-dto';
import { UpdateDataExchangeRequestStatusDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/update-data-exchange-request-status-dto';

@Component({
  selector: 'app-composite-material',
  templateUrl: './composite-material.component.html',
  styleUrls: ['./composite-material.component.scss']
})
export class CompositeMaterialComponent extends CreateUpdatePackagingPartComponent implements OnInit, ComponentCanDeactivate {

  @ViewChild(MultiMaterialTableComponent) private materialsTable!: MultiMaterialTableComponent;

  materialForm!: FormGroup;
  compositeMaterial!: MultiMaterialCompositeDto;

  callerId: number;
  packagingUnitTypeId: number;
  allMaterialFunctions: MaterialFunctionDto[] = [];
  selectedManufacturingCountry = '';
  maxCommentLength = 250;
  materialLayersUpdated = false;
  isDataExchangeSubRequest = false;
  subRequestInfo: DataExchangeSubRequestInfoDto | null = null;
  isInOngoingDataExchange: DataExchangeRequestDto[] = [];
  readonly dataExchangeRequestsPath = '/' + PathResolveService.getDataExchangeRequestsPath(true);
  readonly DataExchangeRequestStatusDto = DataExchangeRequestStatusDto;

  constructor(
    protected handler: CreateUpdateHandler,
    protected dialog: MatDialog,
    protected authService: AuthService,
    protected colorThemeService: ColorThemeService,
    protected cdr: ChangeDetectorRef,
    protected route: ActivatedRoute,
    protected spinner: NgxSpinnerService,
    protected fileApiService: FileApiService,
    protected coreDataUpdateService: CoreDataUpdateService,
    private formBuilder: FormBuilder,
    private materialApiService: MaterialApiService,
    private navigationService: MaterialNavigationService,
    private router: Router,
    private dataExchangeApiService: DataExchangeRequestApiService,
    private directoryApiService: DirectoryApiService,
    private translocoService: TranslocoService
  ) {
    super(handler, dialog, colorThemeService, authService, cdr, route, spinner, fileApiService, coreDataUpdateService);
    this.callerId = PackagingComponentTypesEnum.MainBody;
    this.packagingUnitTypeId = 1;
    this.allMaterialFunctions = this.handler.getMaterialFunctions(this.packagingUnitTypeId, this.callerId);
  }

  ngOnInit(): void {
    this.routeParamsSubscription = this.route.params.subscribe(params => {
      if (params.candidateId) { this.isPreview = true; }
    });
    this.routeDataSubscription = this.route.data.subscribe(data => {
      if (data.compositeMaterial) {
        this.compositeMaterial = data.compositeMaterial;
        this.relevantAnalysisTypes.ccRelevant = data.compositeMaterial.isCCRelevant;
        this.relevantAnalysisTypes.lcaRelevant = data.compositeMaterial.isLCARelevant;
        this.relevantAnalysisTypes.recyclingRelevant = data.compositeMaterial.isRecyclabilityRelevant;
        this.currentDirectoryId = data.compositeMaterial.directoryId;
        this.isTracked = this.compositeMaterial?.hasExternalTracking ?? false;
        this.isHistory = this.compositeMaterial?.id != null && !this.compositeMaterial.isCurrentVersion;
        if (this.materialForm) {
          window.location.reload();
        }
        this.selectedTags = this.allTags.filter(tag => this.compositeMaterial.associatedTagIdentifiers.includes(tag.id ?? -1) ?? false);
      } else if (data.dataExchangeRequest) {
        this.compositeMaterial = data.dataExchangeRequest.multiMaterial;
        this.subRequestInfo = data.dataExchangeRequest.subRequestInfo;
        this.relevantAnalysisTypes.ccRelevant = data.dataExchangeRequest.multiMaterial.isCCRelevant;
        this.relevantAnalysisTypes.lcaRelevant = data.dataExchangeRequest.multiMaterial.isLCARelevant;
        this.relevantAnalysisTypes.recyclingRelevant = data.dataExchangeRequest.multiMaterial.isRecyclabilityRelevant;
        this.currentDirectoryId = data.dataExchangeRequest.multiMaterial.directoryId;
        this.isTracked = this.compositeMaterial?.hasExternalTracking ?? false;
        this.isHistory = this.compositeMaterial?.id != null && !this.compositeMaterial.isCurrentVersion;
        if (this.materialForm) {
          window.location.reload();
        }
        this.selectedTags = this.allTags.filter(tag => this.compositeMaterial.associatedTagIdentifiers.includes(tag.id ?? -1) ?? false);
      } else {
        this.compositeMaterial = CompositeMaterialSevice.createEmptyCompositeMaterial();
      }
      if (data.permissions) {
        this.permissions = data.permissions;
        this.isEditPermitted = this.permissions?.write ?? true;
      }
      if (data.isDataExchangeSubRequest) {
        this.isDataExchangeSubRequest = true;
        if (!data.permissions) {
          this.materialApiService.getMaterialPermissions(this.compositeMaterial.id ?? -1).subscribe(permissions => {
            this.permissions = permissions;
            this.isEditPermitted = this.permissions?.write ?? true;
            this.disableFormIfRequired(this.materialForm);
          });
        }
      }
      if (data.changedSubmaterialIds && data.changedSubmaterialIds.length > 0) {
        this.setChangedSubmaterials(this.compositeMaterial.subMultiMaterials, data.changedSubmaterialIds);
      }
      if (data.isInOngoingDataExchange) {
        this.isInOngoingDataExchange = data.isInOngoingDataExchange;
        if (this.isInOngoingDataExchange.length > 0 && this.compositeMaterial.isCurrentVersion) {
          const firstRequest = this.isInOngoingDataExchange[0];
          const subRequest = firstRequest.subRequests?.find(sr => sr.multiMaterial?.id === this.compositeMaterial.id);
          const path = subRequest
            ? '/' + PathResolveService.getDataExchangeRequestMaterialPath(true, subRequest.id)
            : this.dataExchangeRequestsPath;
          this.router.navigateByUrl(path);
          return;
        }
      }
    });
    this.materialForm = this.formBuilder.group({
      multiMaterialControl: [this.compositeMaterial],
      newVersionName: [''],
      comment: [this.compositeMaterial.comment],
      images: [this.compositeMaterial.images],
      certificates: [this.compositeMaterial.certificates],
      documents: [this.compositeMaterial.documents]
    });
    const lockFunction = (materialId: number) => this.materialApiService.lockCompositeMaterial(materialId, true);
    this.setUpLockAndHeartbeat(this.materialForm, lockFunction, this.compositeMaterial?.id);
    this.disableFormIfRequired(this.materialForm);
    this.historyVersions = [{
      id: this.compositeMaterial.id,
      versionNumber: this.compositeMaterial.version,
      creationTimestamp: this.compositeMaterial.creationTimestamp,
      isCurrentVersion: this.compositeMaterial.isCurrentVersion
    }];
  }

  private setChangedSubmaterials(allSubmaterials: MultiMaterialCompositeDto[], changedSubmaterialIds: number[]) {
    changedSubmaterialIds.forEach(id => {
      const changedSubmaterial = allSubmaterials.find(x => x.id === id);
      if (changedSubmaterial) {
        this.changedPackagingPartsInfo.push({
          id: changedSubmaterial.id ?? -1,
          name: changedSubmaterial.articleName,
          packagingPart: PackagingPart.Material,
          type: '',
          subtype: ''
        });
      }
    });
  }

  onManufacturingCountryChanged(countryCode: string) {
    this.selectedManufacturingCountry = countryCode;
  }

  @HostListener('window:beforeunload')
  canDeactivate(): boolean {
    return (this.materialForm && this.materialForm.pristine && !this.filesEdited)
      || this.isPreview || this.isUserValidator || this.isUserAdmin || this.isHistory;
  }

  async releaseComponent() {
    const releaseFunction = (materialId: number) => this.materialApiService.releaseCompositeMaterial(materialId, true);
    super.releaseComponent(this.compositeMaterial.id, releaseFunction);
  }

  loadHistoryVersions() {
    const versionsFunction = (materialId: number) => this.materialApiService.getCompositeMaterialHistoryVersions(materialId);
    super.loadHistoryVersions(this.compositeMaterial.id, versionsFunction);
  }

  onHistoryVersionChange(version: number) {
    const navigationFunction = (materialId: number, materialVersion?: number) => {
      if (materialVersion == null && this.isInOngoingDataExchange.length > 0) {
        const firstRequest = this.isInOngoingDataExchange[0];
        const subRequest = firstRequest.subRequests?.find(sr => sr.multiMaterial?.id === materialId);
        const path = subRequest
          ? '/' + PathResolveService.getDataExchangeRequestMaterialPath(true, subRequest.id)
          : this.dataExchangeRequestsPath;
        this.router.navigateByUrl(path);
      } else {
        this.navigationService.navigateToMaterial(materialId, materialVersion);
      }
    };
    super.onHistoryVersionChange(version, navigationFunction);
  }

  editVersionName(material: VersionDto) {
    const renameFunction = (id: number, version: number, name: string) =>
      this.materialApiService.renameCompositeMaterial(id, version, name, true);
    super.editVersionName(material, this.compositeMaterial, renameFunction);
  }

  totalWeightChanged(newTotalWeight: number): void {
    const compositeMaterial = this.materialForm.controls.multiMaterialControl.value;
    compositeMaterial.totalWeight = newTotalWeight;
    this.materialForm.controls.multiMaterialControl.patchValue(compositeMaterial);
    this.compositeMaterial.totalWeight = newTotalWeight;
    this.materialLayersUpdated = true;
  }

  private isFormValid() {
    this.materialForm.markAllAsTouched();
    this.materialForm.updateValueAndValidity();
    return this.materialForm.valid;
  }

  private formToDto(): MultiMaterialCompositeDto {
    const formValue = this.materialForm.controls.multiMaterialControl.value;
    if (!this.materialForm || !formValue) { throw new Error('CompositeMaterialComponent: form is undefined'); }
    const material = this.compositeMaterial;
    material.comment = this.materialForm.controls.comment.value;
    material.manufacturerName = formValue.manufacturerName;
    material.articleName = formValue.articleName;
    material.articleNumber = formValue.articleNumber;
    material.manufacturingCountry = formValue.manufacturingCountry;
    material.gtin = formValue.gtin;
    material.totalGrammage = formValue.totalGrammage;
    material.totalWeight = formValue.totalWeight;
    material.versionName = this.materialForm.value.newVersionName;
    return material;
  }

  getUpdatedMaterial(): MultiMaterialCompositeDto {
    return this.formToDto();
  }

  async onSubmit() {
    if (!this.isFormValid()) {
      super.openFormInvalidDialog();
    } else {
      const dirId = this.currentDirectoryId != null ? this.currentDirectoryId : await super.selectDirectory();
      if (dirId == null) { return; }
      this.saveCompositeMaterial(dirId);
    }
  }

  onSubRequestCommentAdded(text: string): void {
    if (!this.subRequestInfo) { return; }
    const subRequestId = this.subRequestInfo.subRequest.id;
    this.dataExchangeApiService.addSubRequestComment(subRequestId, text).subscribe({
      next: () => {
        this.dataExchangeApiService.getSubRequestInfo(subRequestId, true).subscribe({
          next: info => { this.subRequestInfo = info; }
        });
      }
    });
  }

  onApproveSubRequest(): void {
    if (!this.subRequestInfo) { return; }
    const dto: UpdateDataExchangeRequestStatusDto = { status: DataExchangeRequestStatusDto.Closed };
    this.dataExchangeApiService.updateSubRequestStatus(this.subRequestInfo.subRequest.id, dto, true).subscribe({
      next: () => this.router.navigateByUrl('/' + PathResolveService.getDataExchangeRequestsPath(true))
    });
  }

  onReopenSubRequest(): void {
    if (!this.subRequestInfo) { return; }
    const dto: UpdateDataExchangeRequestStatusDto = { status: DataExchangeRequestStatusDto.ReOpened };
    this.dataExchangeApiService.updateSubRequestStatus(this.subRequestInfo.subRequest.id, dto, true).subscribe({
      next: () => this.router.navigateByUrl('/' + PathResolveService.getDataExchangeRequestsPath(true))
    });
  }

  async createDataExchangeRequest(): Promise<void> {
    if (this.compositeMaterial.id == null) { return; }
    const securityPrincipals = await this.directoryApiService.getExternalSecurityPrincipals().toPromise();
    if (!securityPrincipals) { return; }
    const dialogData: CreateDataExchangeRequestDialogData = {
      allPrincipals: securityPrincipals,
      materialIds: [this.compositeMaterial.id]
    };
    const dialogRef = this.dialog.open(CreateDataExchangeRequestDialogComponent, getDialogConfig(dialogData, '50%'));
    dialogRef.afterClosed().subscribe(result => {
      if (!result || result.event === DialogActions.REJECT) { return; }
      this.dataExchangeApiService.createDataExchangeRequest(result.dto, true).subscribe({
        next: _ => {
          const data: SimpleDialogData = {
            title: this.translocoService.translate('common.text.success'),
            messages: [this.translocoService.translate('dataManagement.directory.dialog.dataExchangeRequest.createSuccess')],
            icon: 'info'
          };
          this.dialog.open(SimpleAlertDialogComponent, getDialogConfig(data, '500px'));
        },
        error: _ => {
          const data: SimpleDialogData = {
            title: this.translocoService.translate('common.text.error'),
            messages: [this.translocoService.translate('dataManagement.directory.dialog.dataExchangeRequest.createError')],
            icon: 'error'
          };
          this.dialog.open(SimpleAlertDialogComponent, getDialogConfig(data, '500px'));
        }
      });
    });
  }

  async onFinishRequest() {
    if (!this.isFormValid()) {
      super.openFormInvalidDialog();
      return;
    }
    const material = this.getUpdatedMaterial();
    await super.updateImagesAndDocuments(material);
    const subRequestId = +this.route.snapshot.params['id'];
    this.spinner.show();
    this.dataExchangeApiService.updateSubRequestMultiMaterial(subRequestId, material, true, true)
      .subscribe({
        next: _ => {
          this.spinner.hide();
          Object.keys(this.materialForm.controls).forEach(control => {
            this.materialForm.controls[control].markAsPristine();
          });
          this.materialForm.markAsPristine();
          this.filesEdited = false;
          this.router.navigateByUrl('/' + PathResolveService.getDataExchangeRequestsPath(true) + '?tab=1');
        },
        error: e => {
          this.spinner.hide();
          const dialogData = this.handler.getFailureDialogData(e);
          this.dialog.open(SimpleAlertDialogComponent, getDialogConfig(dialogData, '400px'));
        }
      });
  }

  private async saveCompositeMaterial(directoryId: number) {
    const material = this.getUpdatedMaterial();
    material.directoryId = directoryId;
    await super.updateImagesAndDocuments(material);

    let saveFunction = (packagingItem: MultiMaterialCompositeDto) =>
      this.materialApiService.putCompositeMaterial(packagingItem);

    let navFunction = (id: number, version: number) =>
      this.navigationService.navigateToMaterial(id, version);

    if (this.isDataExchangeSubRequest) {
      const subRequestId = +this.route.snapshot.params['id'];
      saveFunction = (packagingItem: MultiMaterialCompositeDto) =>
        this.dataExchangeApiService.updateSubRequestMultiMaterial(subRequestId, packagingItem);
      navFunction = (id: number, version: number) => {
        const path = PathResolveService.getDataExchangeRequestMaterialPath(true, this.route.snapshot.params['id']);
        this.router.navigateByUrl(path);
      };
    }

    super.putPackagingItem(material, this.materialForm, saveFunction, navFunction);
  }

  setTags() {
    this.compositeMaterial.associatedTagIdentifiers = this.selectedTags.map(tag => tag.id ?? -1);
  }

  async acceptSubmaterialChange(submaterialId: number) {
    if (this.compositeMaterial.id == null) { return; }
    const acceptFunction = (submaterialId: number, componentToAcceptId: number) =>
      this.materialApiService.acceptSubmaterialChange(submaterialId, componentToAcceptId);
    super.acceptChange(this.compositeMaterial.id, submaterialId, acceptFunction);
  }

  declineSubmaterialChange(submaterialId: number) {
    if (this.compositeMaterial.id == null) { return; }
    const declineFunction = (submaterialId: number, componentToAcceptId: number) =>
      this.materialApiService.declineSubmaterialChange(submaterialId, componentToAcceptId);
    super.declineChange(this.compositeMaterial.id, submaterialId, declineFunction);
  }
}
